import { EmbeddedBuilderEntity } from 'components/EmbeddedBuilder';

/**
 * Builders whose form state is a single global redux-form instance: a second copy mounted over a
 * routed create/edit page of the same module would share (and clobber) that page's values.
 */
export const SINGLETON_FORMS: Partial<Record<EmbeddedBuilderEntity, string>> = {
  campaign: 'campaign_form',
  reward: 'reward_form'
};

export const isBuilderBlockedBySingleton = (
  state: { form?: Record<string, unknown> },
  entity: EmbeddedBuilderEntity
): boolean => {
  const formName = SINGLETON_FORMS[entity];
  return Boolean(formName && state.form?.[formName]);
};
